import { RootContainer } from '../../../core/root_container';
import { FeedbackContainer } from '../../../core/views/pc/review/feedback_container';
import { SubstituteItemAreaAction } from '../../../core/actions/substitute_item/substitute_item_area_action';
import { VariationAction } from '../../actions/variation_action';
import { VariationJsEnv } from '../../models/variation_js_env';
import FilterVariationsAttrContainer from './variations_list/filter_variations_attr_container';
import FilterVariationsCategoryContainer from './variations_list/filter_variations_category_container';
import TableTooltipPriceSortContainer from './variations_list/table_tooltip_price_sort_container';
import DomUtil from '../../../core/util/dom_util';
import LoadingUtil from '../../../core/util/loading_util';
import TableTxFilterContentContainer from './variations_list/table_tx_filter_header_content_container';
import TableTooltipAction from '../../actions/table_tooltip_action';
import { TooltipAttrModel } from '../../models/tooltip_model';
import { ComparisonTableAction } from '../../../core/actions/comparison_table/comparison_table_action';
import { BulkAddCartAction } from '../../../core/actions/add_cart/bulk_add_cart_action';
import { isSoloare } from '../../../core/models/js_env';
import { Env } from '../../../core/env';

declare global {
  interface Window {
    TRYLION: {
      Env: { PAGE: VariationJsEnv };
    };
    _tableHeadFollow: any;
  }
}

export class VariationContainer extends RootContainer<VariationJsEnv> {
  constructor(model: VariationJsEnv) {
    super();

    VariationAction.REFRESH_TABLE.on((newDoc) => {
      VariationContainer.toggleFilterAreaIfNoneSelection();

      const NoImageObject = document.getElementById('no-image-variations-askul-original-area') as HTMLDivElement;
      const areaArray = ['#variations-table-all-area'];
      if (NoImageObject !== null) {
        areaArray.push('#no-image-variations-askul-original-area');
      }

      const isSoloareLogin =
        Env.PAGE.isLogin && Env.PAGE.userId
          ? isSoloare(Env.SITE_TYPE) &&
            (Env.PAGE.isLogin as boolean) &&
            (Env.PAGE.userId as string) !== '' &&
            document.getElementById('thinHeader') != null
          : false;

      // ソロアリでログイン中の場合、絞り込み後のスクロールをDomUtil内の処理を使わず下の処理で行う
      const scrollTarget = isSoloareLogin ? undefined : '#variations-scroll-into';

      if (isSoloareLogin) {
        // 画面の他のJS優先初期化させるためにsetTimeout
        setTimeout(() => {
          const selector = document.querySelector('#variations-scroll-into');
          if (selector) {
            // ソロアリでログイン中の場合、スクロール先を追従ヘッダの下に位置するように移動
            window.scroll({ top: selector.getBoundingClientRect().top + window.scrollY - 47 });
          }
        }, 0);
      }

      DomUtil.replace<VariationJsEnv>(newDoc, areaArray, {
        reInitAll: true,
        scrollIntoAnchorSelector: scrollTarget,
        onJsEnvLoaded: (newModel) => {
          this.initFilterAreas(newModel);
          this.hideSearchResultNotExistArea();
        },
        onNoneSelectorMatch: () => {
          this.showSearchResultNotExistArea();
        }
      });
      /// Analyticsの更新
      SubstituteItemAreaAction.setAnalyticsItems(
        'variation',
        '#variations-table-body .o-table_tr',
        '[data-substitute-catalog-item-code]'
      );

      // 絞り込み後の商品エリアに差し替え後、pub-SLP-SRC-012.jsの追従パーツ初期化処理を再実行
      const TableHeadFollow = window._tableHeadFollow;
      if (TableHeadFollow) {
        new TableHeadFollow('#variations-table-all-area'); // NOSONAR
      }

      // 絞り込み後の商品エリアに差し替え後、表のヘッダの高さのサイズ調整処理を実行
      TableTooltipAction.adjustTableHeaderHeightForNoImageVariation()

      // 比較表関連の初期化を行う。
      ComparisonTableAction.reInit();

      // 画像無しバリエにおける、複数商品を一括でカゴの再初期化を行う
      BulkAddCartAction.reInit();
    });

    LoadingUtil.onHistoryBack((newDoc) => VariationAction.REFRESH_TABLE.trigger(newDoc));

    // レビューエリアのJS
    model.reviewJSOptions.forEach((opt) => {
      FeedbackContainer.init(opt.feedBackModel);
      // R1で商品詳細とバリエーション一覧画面の「編集」「削除」非表示
      // DeleteLinkContainer.init(opt.deleteReviewModel);
    });

    this.initFilterAreas(model);

    // 初回描画
    this.update(model);

    /// レビューの「続きを見る」リンク押下
    document.querySelectorAll('.js-textaccordion_btn').forEach(function (target) {
      target.addEventListener('click', (e) => {
        const target = e.target as HTMLElement;
        VariationAction.REVIEW_CARD_EVENT.trigger({ target: target });
      });
    });

    // レビューのユーザー名リンク押下
    document.querySelectorAll('.m-userreview_user').forEach(function (target) {
      target.addEventListener('click', (e) => {
        const target = e.target as HTMLElement;
        VariationAction.REVIEW_USER_NAME_EVENT.trigger({ target: target });
      });
    });

    // 「全てのレビューを見る」リンク押下
    document.querySelector('#view-all-reviews-link')?.addEventListener('click', (e) => {
      const target = e.target as HTMLElement;
      VariationAction.VIEW_ALL_REVIEWS_EVENT.trigger({ target: target });
    });

    // レビューを書くボタン 計測
    document.querySelectorAll('button[data-url]')
      .forEach((button, index, array) => {
        button.addEventListener('click', () => {
          VariationAction.reviewButton(button, index, array);
        });
      });
  }

  private showSearchResultNotExistArea() {
    this.toggleSearchResultNotExistArea(true);
  }
  private hideSearchResultNotExistArea() {
    this.toggleSearchResultNotExistArea(false);
  }
  private toggleSearchResultNotExistArea(isShowError: boolean) {
    VariationContainer.toggleSelector('.variations-search-result-not-exist-area', isShowError);
    VariationContainer.toggleSelector('.variations-search-result-exist-area', !isShowError);
  }

  private initFilterAreas(model: VariationJsEnv) {
    // 絞り込みエリア（カテゴリー、１クリックで複数削除）
    model.variationsCategoryJSOptions.forEach((opt) => {
      FilterVariationsCategoryContainer.init(opt);
    });

    // 絞り込みエリア（カテゴリー以外、１クリックで単一削除）
    model.variationsAttrJSOptions.forEach((opt) => {
      FilterVariationsAttrContainer.init(opt);
    });

    // バリエーション一覧テーブルのヘッダー（価格でソート）
    model.tooltipSortPriceJSOptions.forEach((opt) => {
      TableTooltipPriceSortContainer.init(opt);
    });

    // バリエーション一覧テーブルのヘッダー（属性でフィルタ）
    model.tooltipAttrJSOptions.forEach((opt) => {
      VariationContainer.addTooltipEvent(opt, false);
    });

    // 販売単位
    VariationContainer.addTooltipEvent(model.tooltipSellUnitJSOptions, true);

    // 表示項目設定
    TableTxFilterContentContainer.init(model.tableTxFilterHeaderModelJSOption);

    // 「改ページ」リンクと「すべての絞り込み条件を解除して全 Xxx 商品を見る」リンク
    LoadingUtil.asyncPageWithSelectors(['.pagingBtns', '.clearAllFilterConditions'], (newDoc, target) => {
      VariationAction.REFRESH_TABLE.trigger(newDoc);
      if(target != null){
        /// ページングを押されたか、確認する
        if (target.classList.contains('pagingBtns') === true){
          TableTooltipAction.SEND_VARIATION_LIST_PAGING_EVENT.trigger({
            linkName: 'pagingPjax',
            target: target
          });
        } else {
          TableTooltipAction.SEND_VARIATION_SEARCH_EVENT.trigger({
            linkName: 'vrSearchPjax',
            target: target
          });
        }
      }
    });
  }

  // すべて選択しない時点で、絞り込みエリア全体が消えるように
  private static toggleFilterAreaIfNoneSelection() {
    const hasSelection = document.querySelectorAll('.viriations-filter-area-item').length > 0;
    VariationContainer.toggleSelector('.viriations-filter-area', hasSelection);
  }

  private static toggleSelector(selector: string, isShow: boolean) {
    document.querySelectorAll(selector).forEach((el) => {
      const area = el as HTMLElement;
      if (area.style) {
        area.style.display = isShow ? 'block' : 'none';
      }
    });
  }

  private static addTooltipEvent(tooltip: TooltipAttrModel, isSellUnit: boolean) {
    // すべて選択ボタンイベント追加
    document
      .querySelector(`#${tooltip.id} .a-textlink.js-checkboxctrl_all`)
      ?.addEventListener('click', () => {
        TableTooltipAction.selectAllAttrs(tooltip);
      });
    // クリアボタンイベント追加
    document
      .querySelector(`#${tooltip.id} .a-textlink.js-checkboxctrl_clear`)
      ?.addEventListener('click', () => {
        TableTooltipAction.clearAllAttrs(tooltip);
      });
    // チェックボックスイベント追加
    const checkBoxList = document.querySelectorAll(
      `#${tooltip.id} .m-checkboxListItem input[type="checkbox"]`
    ) as NodeListOf<HTMLInputElement>;
    checkBoxList.forEach((checkbox, index) => {
      checkbox.addEventListener('change', () => {
        TableTooltipAction.changeAttr(tooltip, index, checkbox.checked);
      });
    });
    // 適用ボタンイベント追加 m-btn -tertiary -small -noPadding
    document.querySelector(`#${tooltip.id} .m-btn.-tertiary.-small.-noPadding`)?.addEventListener('click', (event: Event) => {
        const target = event.currentTarget as HTMLElement;
        if (isSellUnit) {
          TableTooltipAction.searchBySelectedSellUnits(tooltip, target);
        } else {
          TableTooltipAction.searchBySelectedAttrs(tooltip, target);
        }
      });
  }
}
